import { type FC, memo } from "react";
import { TableCell, TableRow } from "~/common/components/Table/TableElements";
import { type AccountInfoData } from "~/features/b2bAccountSelection/components/AccountSelectionTabelView/api/GetAccountList";
import Radio from "~/common/components/Radio";
import { useTranslation } from "react-i18next";

interface Props {
  item: AccountInfoData;
  isSelected: boolean;
  onRadioClickChangeActiveState: (item: AccountInfoData) => void;
}

const TVAccountSelectionResultsTableRow: FC<Props> = ({ item, onRadioClickChangeActiveState, isSelected }) => {
  const { t } = useTranslation();
  return (
    <TableRow>
      <TableCell>
        <Radio active={isSelected} onClick={() => onRadioClickChangeActiveState(item)} />
      </TableCell>
      <TableCell sx={{ width: "20%", pl: "34px !important" }}>
        <p className={"m-0"}>{item.endCustomerName === "" ? "-" : item.endCustomerName}</p>
        <p className={"mb-0 mt-1 f-label-color"}>{item.endCustomerCode === "" ? "-" : item.endCustomerCode}</p>
      </TableCell>
      <TableCell sx={{ width: "20%", pl: "34px !important" }}>
        <p className={"m-0"}>{item.name === "" ? "-" : item.name}</p>
        <p className={"mb-0 mt-1 f-label-color"}>{item.number === "" ? "-" : item.number}</p>
      </TableCell>
      <TableCell sx={{ width: "20%", pl: "34px !important" }}>
        <p className={"m-0"}>{item.region === "" ? "-" : item.region}</p>
        <p className={"mb-0 mt-1 f-label-color"}>{item.country === "" ? "-" : item.country}</p>
      </TableCell>
      <TableCell sx={{ width: "20%", pl: "34px !important" }}>
        <p className={"m-0"}>{item.endCustomerSector === "" ? "-" : item.endCustomerSector}</p>
      </TableCell>
      <TableCell sx={{ width: "20%", pl: "34px !important" }}>
        <p className={"mb-0"}>{item.currency === "" ? "-" : item.currency}</p>
      </TableCell>
    </TableRow>
  );
};

export default memo(TVAccountSelectionResultsTableRow);
